import { createSlice } from "@reduxjs/toolkit";

const cartListSlice = createSlice({
  name: "cartList",
  initialState: [],
  reducers: {
    addItem(state, action) {
      const cartSlugs = state.map((cartItem) => cartItem.slug);
      if (cartSlugs.includes(action.payload.slug)) {
        const item = state.find((item) => item.slug === action.payload.slug);
        item.quantity = Number(item.quantity) + Number(action.payload.quantity);
        return;
      }
      state.push(action.payload);
    },
    removeItem(state, action) {
      return state.filter((item) => item.slug !== action.payload.slug);
    },
    editItem(state, action) {
      state.map((item) => {
        if (item.slug === action.payload.slug) {
          item.quantity = action.payload.quantity;
        }

        return item;
      });
    },
    resetCartList(state, action) {
      return [];
    },
  },
});

export const { addItem, removeItem, editItem, resetCartList } =
  cartListSlice.actions;

export default cartListSlice.reducer;
